import { computed, Ref } from "@vue/composition-api";
import { uniq, without } from "lodash";
import { Group } from "@scrile/api-provider/dist/api/GroupsProvider";
import { MassMessage } from "@scrile/api-provider/dist/api/MassMessageProvider";
import { GroupMap, RecipientsCountMap } from "@/views/PageScheduledMassMessage/type";

export default function useRecipients(groupList: Ref<Group[]>, massMessageList: Ref<MassMessage[]>) {
  const groupMap = computed<GroupMap>(() => {
    return groupList.value.reduce<GroupMap>((acc, group) => {
      acc[group.id] = group;
      return acc;
    }, {});
  });
  const getUniqIdsFromGroupByIds = (ids: string[]): string[] => {
    const result = ids.reduce<string[]>((acc, i) => {
      if (groupMap.value[i]) {
        acc.push(...groupMap.value[i].memberIds);
      }
      return acc;
    }, []);
    return uniq(result);
  };

  const getRecipients = (message: MassMessage): number => {
    const excludedUserIds = getUniqIdsFromGroupByIds(message.excludedGroupIds);
    const selectedUserIds = getUniqIdsFromGroupByIds(message.groupIds);

    const recipientsIds = without(selectedUserIds, ...excludedUserIds);
    return recipientsIds.length;
  };
  const recipientsCountMap = computed<RecipientsCountMap>(() => {
    return massMessageList.value.reduce<RecipientsCountMap>((acc, message) => {
      acc[message.id] = getRecipients(message);
      return acc;
    }, {});
  });

  return {
    recipientsCountMap,
  };
}
